export default {
  protectionServicesTitle: {
    id: 'nav_services_protection_title',
    defaultMessage: 'BackUp protection',
  },
  protectionServicesDescription: {
    id: 'nav_services_protection_description',
    defaultMessage: 'You ask. We repair. No questions asked.',
  },
  protectionServicesCta: {
    id: 'nav_services_protection_cta',
    defaultMessage: 'Explore protection plans',
  },
  repairServicesTitle: {
    id: 'nav_services_repair_title',
    defaultMessage: 'Repair services',
  },
  repairServicesDescription: {
    id: 'nav_services_repair_description',
    defaultMessage: 'Get a quote from our repair partners or repair yourself.',
  },
  repairServicesCta: {
    id: 'nav_services_repair_cta',
    defaultMessage: 'Repair your tech',
  },
  expressReplacementTitle: {
    id: 'nav_services_express_replacement_title',
    defaultMessage: 'Express Replacement',
  },
  expressReplacementDescription: {
    id: 'nav_services_express_replacement_description',
    defaultMessage:
      'Not happy with your device? We ship your replacement first. For free.',
  },
  expressReplacementCta: {
    id: 'nav_services_express_replacement_cta',
    defaultMessage: 'Replace device',
  },
}
